import React from "react";
import TourSummaryProductsRow from "./TourSummaryProductsRow";

const TourSummaryProductsTable = ({ token, tourId, products, unitSales, recipientNames, userIsEditor }) => {

  return (
    <table>
      <thead>
          <tr>
            <th className="left">Description</th>
            <th className="left">Units sold</th>
            <th className="right">Price (£)</th>
            {
              recipientNames.length > 0 && recipientNames.map((name, index) => {
                return (
                  <th className="right hideLtTablet" key={index}>{name}</th>
                )
              })
            }
          </tr>
        </thead>
      <tbody>
        {
          products.length === 0
          ?
          (
            <tr>
              <td colSpan="5">No Products added yet</td>
            </tr>
          )
          :
          products.map(product => {
            const currentProduct = unitSales.find(sale => sale.id === product._id) || { units: 0 };
            return (
              <TourSummaryProductsRow
                key={product._id}
                token={token}
                tourId={tourId}
                product={product}
                units={currentProduct.units}
                recipientNames={recipientNames}
                userIsEditor={userIsEditor}
              />
            )
          })
        }
      </tbody>
    </table>
  )

};

export default TourSummaryProductsTable;